module.exports = __webpack_public_path__ + "static/media/cart-icon.51c14dc7.svg";